// extracted by mini-css-extract-plugin
export default {"modalTitle":"DuplicateFormPopup_modalTitle__B3UUY","closeModalButton":"DuplicateFormPopup_closeModalButton__LnJPs","buttonSection":"DuplicateFormPopup_buttonSection__DvYBf"};